webpackJsonp([248002569926196],{

/***/ 1050:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0031_leaping_lizard.jpg","type":"Unit","subtype":"Lizardman","cost":1,"ATK":3,"HP":5,"rules_text_1":"Anti-air (Can attack fliers, but can ignore patrolling fliers. Deals combat damage to fliers it fights or that fly over this while it patrols.)","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Leaping Lizard","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"He can reach for the sky.","color":"Neutral","spec":"Finesse","bottom":"Tech II","rulings":[],"keywords":["Anti-air"],"slug":"leaping_lizard"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"leaping_lizard","keywords":["Anti-air"],"imageRegex":"/leaping_lizard.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-leaping-lizard-d11c73af0c1610209599.js